import LocaleMixin from '../mixins/locale'
import Vue from 'vue'

// Inject mixins globally
Vue.mixin(LocaleMixin)
